// ActionType: leaveRequest
// Send Leave Request
export const SEND_LEAVE_REQUEST = "SEND_LEAVE_REQUEST";
export const SEND_LEAVE_REQUEST_SUCCESS = "SEND_LEAVE_REQUEST_SUCCESS";
export const SEND_LEAVE_REQUEST_FAIL = "SEND_LEAVE_REQUEST_FAIL";
